module.exports = __webpack_public_path__ + "img/executor.9fcf4e4a.svg";